<template>
  <div class="components-container" >
        <div class="left-container" style="display:flex"  >
          <div style="display:flex;" id="pdftree" >
        <el-aside style="width:100%">
          <!-- 审查意见录入 -->
            <el-card v-show="opinion_show">
              <el-row style="text-align: left;">审查意见录入</el-row> 
              <el-form ref="opinionForm" style="text-align: left;" label-width="120px" :model="opinionForm" size="small">
                <el-form-item prop="problemType" label="违反类别:" style="justify-content:flex-start"  >
                  <el-select v-model="opinionForm.problemType" placeholder="请选择" style='width:100%' @change="qiangtiao">
                    <el-option v-for="item in problemTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <div v-show="qiangtiaos">
                <el-form-item prop="problemSubMajor" label="强标强条类型:" v-if='opinionForm.problemType=="其他问题"'>
                  <el-select v-model="opinionForm.problemSubMajor" placeholder="请选择" style='width:100%' clearable >
                    <el-option v-for="item in problemSubMajorOptions" :key="item.value" :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="problemSubMajor" label="强标强条类型:" :rules='{required:false,message:"该项必填"}'>
                  <el-select v-model="opinionForm.problemSubMajor" placeholder="请选择" style='width:100%' clearable>
                    <el-option v-for="item in problemSubMajorOptions" :key="item.value" :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                </div>
                <div v-show="perfesion">
                  <el-form-item prop="professional" label="专业类型:" :rules='{required:false,message:"该项必填"}'>
                    <el-select v-model="opinionForm.professional" placeholder="请选择" style='width:100%' clearable :disabled="professionals">
                      <el-option v-for="item in professionalMB" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-form label-position="top" size="small" :model="opinionForm">
                  <el-form-item prop="hiddenDangerReason" label="安全说明:"
                                v-if='Number(opinionForm.isHiddenDanger)&&opinionForm.dangerType=="严重"'
                                :rules='{required:true,message:"该项必填"}'>
                    <el-input type="input" placeholder="请输入内容" v-model="opinionForm.hiddenDangerReason"
                              :autosize="{minRows: 3, maxRows: 3}">
                    </el-input>
                  </el-form-item>
                  <template v-if='opinionForm.problemType =="其他问题"'>
                    <el-form-item prop="gb" label="违反条目:">
                      <el-input type="textarea" :autosize="{minRows: 3, maxRows: 3}"  placeholder="请输入内容"
                                v-model="opinionForm.gbdescription">
                      </el-input>
                      <span>{{opinionForm.gbcaption}}</span>
                    </el-form-item>
                  </template>
                  <template>
                    <el-form-item prop="normalName" 
                                  :rules='{required:(opinionForm.problemType != "其他"),message:"该项必填"}'>
                      <span style="text-align:right;vertical-align:top">规范名称: </span>
                      <el-input type="textarea"   :autosize="{minRows: 2, maxRows: 2}"  placeholder="请输入内容" style="width:70%"
                                v-model="opinionForm.normalName">
                      </el-input>
                    </el-form-item>
                  </template>
                  <template>
                    <el-form-item prop="normalNum" 
                                  :rules='{required:(opinionForm.problemType != "其他"),message:"该项必填"}'>
                      <span style="text-align:right;vertical-align:top">规范编号: </span>
                      <el-input type="textarea" :autosize="{minRows: 2, maxRows: 2}"  placeholder="请输入内容" style="width:70%"
                                v-model="opinionForm.normalNum">
                      </el-input>
                    </el-form-item>
                  </template>
                  <template>
                    <el-form-item prop="clauseNum" 
                                  :rules='{required:(opinionForm.problemType != "其他"),message:"该项必填"}'>
                      <span style="text-align:right;vertical-align:top">&nbsp;条 款 号: </span>
                      <el-input type="textarea" :autosize="{minRows: 2, maxRows: 2}"   placeholder="请输入内容" style="width:70%"
                                v-model="opinionForm.clauseNum">
                      </el-input>
                    </el-form-item>
                  </template>
                  <el-form-item prop="problemDescription" :rules='{required:false,message:"该项非必填"}'>
                    <span style="text-align:right;vertical-align:top">问题描述: </span>
                    <el-input type="textarea"  :autosize="{minRows:10, maxRows: 10}" placeholder="请输入内容" style="width:70%;resize: both;"
                              v-model="opinionForm.problemDescription">
                    </el-input>
                  </el-form-item>
                </el-form>
              </el-form>

              <el-row style="text-align: center;">
                <el-col :span="6">
                  <el-button type="primary" size="mini" @click="submitProblem_handle" :disabled='myself'>保存意见
                  </el-button>
                </el-col>
                <el-col :span="6" :push='3'>
                  <el-button type="primary" size="mini" @click="criterion_show=true">查询标准</el-button>
                </el-col>
                <el-col :span="6" :push='6'>
                  <el-button type="primary" size="mini" @click="common_show=true">常用意见</el-button>
                </el-col>
              </el-row>
              <el-row style="text-align: center; margin-top: 10px">
                <el-col :span="6">
                  <el-button type="primary" size="mini" @click="resetForm('opinionForm')">清空表单</el-button>
                </el-col>
                <el-col :span="6" :push="3">
                  <el-button type="primary" size="mini" @click="copyOpinion">复制意见</el-button>
                </el-col>
                <el-col :span="6" :push="6">
                  <el-button type="primary" size="mini" @click="pasteOpinion" :disabled="!COPYOPINION">粘贴意见</el-button>
                </el-col>
              </el-row>
              <el-row style="text-align:center; margin-top: 10px">
                <el-col :span="6">
                  <el-button type="primary" size="mini" @click="goTree">返回目录</el-button>
                </el-col>
              </el-row>
            </el-card>

          <!-- tree -->
          <!-- 左则操作栏 -->
          <el-tabs v-show="!opinion_show" v-model="activeName" type="card">
            <el-tab-pane name="tuzhi">
                <span slot="label">图纸信息</span> 
                <!-- 树形结构图 --> 
                <div style="height: 400px;overflow-y: auto;">
                   <el-tree
                      :data="tree.data"
                      node-key="id"
                      ref="tree"
                      :loading="tree.loading"
                      show-checkbox
                      @node-click="selectTreeID"
                      highlight-current
                      :props="defaultProps" 
                    >
                      <span slot-scope="scope" :title="scope.data.label">
                          <!--图纸是否有意见-->
                        <i v-if="scope.data.drawingOpinion == '1'" class="el-icon-tickets" style="color: #409eff;"></i>
                        <span>{{scope.data.label}}</span>
                         <!-- <i class="el-icon-edit" style="color: #409eff;"
                          v-if="scope.data.type == 'archive'&&!scope.data.readOnly"></i>
                        <i
                          :class="[scope.data.type != 'drawing' ? 'el-icon-tem-wenjianjia' : 'el-icon-tem-wenben']"></i>{{scope.data.name}}{{scope.data.numbertext}}
                        <span
                          v-if="scope.data.type == 'archive'"
                          :class="[scope.data.checkOn > 0 ? 'font-green' : scope.data.status == '已退回' ? 'font-red' : '']">
                          ({{scope.data.status}}){{scope.data.archiveStatus==2?'('+'缺图纸'+')':''}}
                        </span> -->
                      </span>
                    </el-tree>
                </div>
                <!-- —————— -->

                <!-- 操作模块1 -->
                <div style="width: 200px;margin: 0 auto;padding-bottom: 10px">
                  <el-row style='padding-top:10px'>
                    <!--<el-button size='small' @click='diffPDF' type='primary' style='width:100%'>
                      <!-- {{diffPDFName}} 
                      同图对比 
                    </el-button>-->
                  </el-row>
                  <el-row style='padding-top:10px;' v-if='recheck'>
                    <!-- <el-button size="small" @click="paf_back(true)" type="primary" style='width: 100%'>图纸退回</el-button> -->
                  </el-row>
                  <el-row style='padding-top:10px;' v-if="taskCensorCircs == '4'">
                    <!-- <el-button size="small" @click="pdf_cancel()" type="primary" style='width: 100%'>图纸作废</el-button> -->
                  </el-row>
                  <template v-if='showexport'>
                    <template v-if='showpost'>
                      <div v-if="showInfo">
                        <el-row style='padding-top:10px;'>
                          <!-- <el-button :disabled="noDrawing" size="small" 
                                    v-if="this.taskCensorCircs == '2'"
                                    @click="onPDF_addnew" type="primary"
                                    style='width: 100%'>添加审查意见
                          </el-button>-->
                        </el-row>
                      </div>
                      <div v-else>
                        <el-row v-if="clickedNodeData.checkOnReson">
                          <el-col style="text-align:left;">
                            <!-- <span class="font-red">上次退回原因：{{clickedNodeData.checkOnReson}}</span> -->
                          </el-col>
                        </el-row>
                      </div>
                    </template>
                      <template v-if="taskCensorCircs == '4' || taskCensorCircs == '2'">
                      <el-row style='text-align: center;padding-top:10px;'>
                        <!-- <el-button type='primary' @click='no_drawing' size='small' style='width:100%' :disabled="backOn">缺图纸</el-button> -->
                      </el-row>
                    </template>
                 
                    <template v-if="backToMasterCheckOnStatus">
                      <el-row style='text-align: center;padding-top:10px;'>
                        <!-- <el-button type='primary' @click="updatebackToMasterCheckOn" size='small' style='width:100%'>退回审查人</el-button> -->
                      </el-row>
                    </template>
                    <template v-if="dwgDownload">
                      <el-row style='text-align: center;padding-top:10px;'>
                        <!-- <el-button type='primary' size='small' style='width:100%' @click="download_dwg">下载DWG文件</el-button> -->
                      </el-row>
                    </template>
                  </template> 
                </div>
                <!-- ———————— -->
              </el-tab-pane>

           <!-- 审查意见查看 self 
              <el-tab-pane label='审查意见' v-if='self_work.length&&problem_show'>
                <el-row style='overflow: auto;max-height:800px'>
                  <div style='width:100%;'>
                    <el-table :data='self_work' @cell-dblclick='pdfset' @select='self_wens' @select-all='self_wens'>
                      <el-table-column type='index' width='20'></el-table-column>
                      <el-table-column type='selection' width='30'></el-table-column>
                      <el-table-column label="图纸编号" prop='drawingNumber' align="center"></el-table-column>
                      <el-table-column label='审查问题' prop='problemDescription' align='center'></el-table-column>
                      <el-table-column label='规范名称' prop='normalName' align='center'></el-table-column>
                      <el-table-column label='规范编号' prop='normalNum' align='center'></el-table-column>
                      <el-table-column label='条款号' prop='clauseNum' align='center'></el-table-column>
                      <el-table-column label='专业类型' prop='professional' align='center' width='100'></el-table-column>
                      <el-table-column label='问题类别' prop='problemType' align='center' width='100'></el-table-column>
                      <el-table-column label='问题子专业' prop='problemSubMajor' align='center' width='100'></el-table-column>
                    </el-table>
                  </div>
                </el-row>
                <el-row style='margin-top:10px;text-align:center'>
                  <el-button type='danger' :disabled='!self_wensdata.length' @click='self_all_del("self")'>删除</el-button>
                </el-row>
              </el-tab-pane>-->

          <!-- 审查意见查看 -->
              <el-tab-pane label='审查意见' v-if='this.body_work.length>0&&problem_show'>
                <el-row style='overflow: auto;max-height:800px'>
                  <div style='width:100%;'>
                    <el-table   :data='body_work' @cell-dblclick='pdfword' @select='body_wens' @select-all='body_wens'>
                      <!-- <template slot-scope='scope'>
                        <template v-if="scoped.row.profession == '建筑'"> -->
                          <el-table-column type='index' width='20'></el-table-column>
                          <el-table-column type='selection' width='30'></el-table-column>
                          <el-table-column label="图纸编号" prop='drawingNumber' align="center"></el-table-column>
                          <el-table-column label='审查问题' prop='problemDescription' align='center'></el-table-column>
                          <!-- <el-table-column label='违反条目' prop='gbdescription' align='center'></el-table-column> -->
                          <el-table-column label='规范名称' prop='normalName' align='center'></el-table-column>
                          <el-table-column label='规范编号' prop='normalNum' align='center'></el-table-column>
                          <el-table-column label='条款号' prop='clauseNum' align='center'></el-table-column>
                          <el-table-column label='专业类型' prop='professional' align='center' width='100'></el-table-column>
                          <el-table-column label='问题类别' prop='problemType' align='center' width='100'></el-table-column>
                          <el-table-column label='问题子专业' prop='problemSubMajor' align='center' width='100'></el-table-column>
                        <!-- </template>
                      </template> -->
                    </el-table>
                  </div>
                </el-row>
                <el-row style='margin-top:10px;text-align:center'>
                  <el-button type='danger' :disabled='!body_wensdata.length' @click='self_all_del("body",false)'>删除
                  </el-button>
                </el-row>
              </el-tab-pane>

         <!-- 审查意见查看 other 
              <el-tab-pane label='其他专家意见' v-if='showexport&&other_work.length'>
                <el-row style='overflow: auto;max-height:800px'>
                  <div style='width:100%' class='3'>
                    <el-table :data='other_work' @cell-dblclick='pdfset' @select='other_wens' @select-all='other_wens'>
                      <el-table-column type='index' width='20'></el-table-column>
                      <el-table-column type='selection' width='30'></el-table-column>
                      <el-table-column label="图纸编号" prop='drawingNumber' align="center"></el-table-column>
                      <el-table-column label='审查问题' prop='problemDescription' align='center'></el-table-column>
                      <el-table-column label='规范名称' prop='normalName' align='center'></el-table-column>
                      <el-table-column label='规范编号' prop='normalNum' align='center'></el-table-column>
                      <el-table-column label='条款号' prop='clauseNum' align='center'></el-table-column>
                      <el-table-column label='专业类型' prop='professional' align='center' width='100'></el-table-column>
                      <el-table-column label='问题类别' prop='problemType' align='center' width='100'></el-table-column>
                      <el-table-column label='问题子专业' prop='problemSubMajor' align='center' width='100'></el-table-column>
                    </el-table>
                  </div>
                </el-row>
              </el-tab-pane>-->
            </el-tabs>
        </el-aside>
        </div>
        <div id="dragbar" class="resize" ref="resize" style="background:#409eff;"></div>

           <div class="bottom-container" style="width:100%;" id="pdfplugin">
          <!-- <el-main style="margin-left:2px"> -->
            <el-row style="text-align: center">
              {{opinionFormname}}
            </el-row>
            <!-- <el-row>
              <hr size="1" style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 20px" />
            </el-row> -->
            <el-row style="height:100%">
              <!--<iframe :src="iframe_url" frameborder="0" style="width: 100%;height: 900px;" ></iframe>-->
              <div class="main" style="border:1px solid #000;width:100%;height:100%">
                <div class="pdf-info"></div>
                <div class="pdf-wrapper" style="border:1px solid #000;width:100%;height:100%;">
                  <div id="pdf-container" class="pdf-container" style="border:1px solid #000;width:100%;height:100%;"></div>
                </div>
              </div>
            </el-row>
        
          <!-- </el-main> -->
        </div>


          <!-- dialog常用意见模块 -->
          <el-dialog @close='common_show=false' :visible='common_show' width='80%' title='常用意见'>
            <el-form :model='common_form.data' size='small'>
          <el-form-item prop='search' >
              <el-row>
                  <!-- <el-col :span='10'>
                      <el-select>
                          <el-option></el-option>
                      </el-select>
                  </el-col> -->
                  <el-col :span='10' >
                  <el-form-item  style="width:100%" prop = "keyword">
                      <el-input placeholder="请输入关键字" v-model.trim="common_form.data.keyword" @keydown.enter.native="query"></el-input>
                        </el-form-item>
                  </el-col>
                  <el-col :span='4'>
                      <el-button type="primary" @click="query1">查询</el-button>
                      <el-button type="info" @click="clean">清除筛选</el-button>
                  </el-col>
              </el-row>
          </el-form-item>
          </el-form> 
            <el-row>
              <el-table :data='commonlist.data' @cell-dblclick='cellCommon' v-loading="table.loading">
                <el-table-column prop='violateType' label='违反类别'>
                </el-table-column>
                <el-table-column prop='mandatoryStandardType' label='强标强条类型'>
                </el-table-column>
                <el-table-column label='规范名称' prop='normalName' align='center'></el-table-column>
                <el-table-column label='规范编号' prop='normalNum' align='center'></el-table-column>
                <el-table-column label='条款号' prop='clauseNum' align='center'></el-table-column>
                <el-table-column prop='commonStandar1' label='问题描述'></el-table-column>
                
              </el-table>
            </el-row>
            <el-row style='text-align: right'>
              <el-pagination 
              layout="prev, pager, next" 
              :page-size='10' 
              :current-page='commonlist.currentPage'
              :total='commonlist.total' 
              @current-change='getcommon'
              ></el-pagination>
            </el-row>
          </el-dialog>
          <!-- _____ -->

          <!-- 标准查询模块 -->
          <el-dialog :visible='criterion_show' @close='criterion_show=false' width='70%' title='标准查询'>
            <el-form :model='criterion_form' label-width='100px' size='small'>
              <el-form-item prop='' label='查询标准:'>
                <el-row>
                  <el-col :span='10'>
                    <el-col :span='8'>
                      <el-select style='width:100%' v-model='standard'>
                        <el-option v-for='item in standard_data' :value='item' :key='item' :label='item'></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span='12'>
                      <el-input v-model='standCaption' :disabled='!standard' @keydown.native.enter='getstandList'
                                placeholder="查询所有"></el-input>
                    </el-col>
                    <el-col :span='4'>
                      <el-button size='small' @click='getstandList' :disabled='!standard'>查询</el-button>
                    </el-col>
                  </el-col>
                  <el-col :span='10'>
                    <el-col :span='19'>
                      <el-form-item label='结果搜索'>
                        <el-input v-model='stand_search'  @keydown.native.enter='getstandData'></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span='3' :push='1'>
                      <el-button size='small' @click='getstandData' >搜索</el-button>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
               <el-row style='height:600px'>
                <!-- 显示标号  :disabled='!stdid' :disabled='!stdid'
                <el-col :span='6' style='height: 100%;'>
                  <div class='criterion_item'>
                    <div v-for="item in common_list" :class="{'active':stdid==item.no}" @click="stdid=item.no">
                      {{item.caption}}
                      <div>({{item.stdid}})</div>
                    </div>
                  </div>
                </el-col>
                <!-- 显示图片和内容 -->
                <el-col :span='18' style='height: 100%;'>
                  <div class='criterion_item'>
                    <template v-for="item in stand_contant">
                      <div v-if='item.genre === 2' style="font-size: 16px;color: #303030;">
                        <img :src="'http://119.3.104.48:8088/std_images/'+(parseInt(item.no/2000)+1)+'/'+item.no+'/'+item.content" :alt="item.chapter" style="max-width: 100%">
                      </div>
                      <div v-else style="font-size: 16px;color: #303030;" @dblclick="selectDrp(item)">
                        <template v-if='item.genre===0'>
                          <span style="margin-right: 10px;">{{item.chapter}}</span>
                          <span v-html="item.content"></span>
                        </template>
                        <template v-else>
                          <span v-html="item.content"></span>
                        </template>
                      </div>
                    </template>
                  </div>
                </el-col>
              </el-row> 
            </el-form>
          </el-dialog>
    </div>
  </div>
</template>
<script>
import { PDFPlugin,openPDF,getNewFlags,compareTwo,removeFlags,reload,PDFEditorWindow,bindReviewComments} from "../../styles/js/pdf.plugin";
import {
    PROBLEM_TYPE_OPTIONS,
    PROBLEM_STRONG_OPTIONS,
    PROBLEM_SUBMAJOR_OPTIONS,
    DANGER_TYPE_OPTIONS,
    PROFESSIONALCON1,
    PROFESSIONALCON2,
    PROFESSIONALCON3,
    PROFESSIONALCON4,
    PROFESSIONALCON5
  } from './constants.js'
export default {
  components: {},
  data() {
    return {
        backOn:true,
        opinion_show:false,
        COPYOPINION: '',
        myself:false,
        opinionFormname:'',
        opinionForm: {
          problemType: '',
          problemSubMajor: '',
          isHiddenDanger: 0,
          dangerType: '',
          gbdescription: '',
          normalName:'',//规范名称
          normalNum:'',//规范编号
          clauseNum:'',//条款号
          problemDescription: '',
          drawingNumber: null,
          projectID: '',
          professional:'',
          hiddenDangerReason: '',
          opinionType: '',
        },
        diffPDFName: '开始对比',
      url: {
        tasks: "/draw/tasks",
        upload: "/draw/att/uploadatt",
        drawing: "/draw/drawing",
        problemSave: '/draw/problem/save/',
        commonlist: '/draw/problem/common',
        uploadupdateatt: "/draw/att/uploadupdateatt",
        session: "/draw/userinfo/session",
        addAbarbeitungReplyBeginTime: "/draw/tasks/addAbarbeitungReplyBeginTime",
        addAbarbeitungReplyBeginTime1: "/draw/tasks/addAbarbeitungReplyBeginTime",
        query1: 'draw/problem/common',
        standard: '/draw/standard/profession',
        problemSubmit: '/draw/problem/submit',
        problem: '/draw/problem/query',
        rsi: '/rsi/StdContent.ashx',//标准接口（老接口不可用）
        alldelete: '/draw/problem/batch-delete',
        problems: "/draw/problem/list",
        getProblems: '/draw/problem/no-paging',



      },
      pjid:'',//projectID
      shenchaid : '',
      standCaption: '',
      standard: '',
      stand_search: '',
      self_wensdata: [],
      acr :'',
      common_list: [],
      stand_contant: [],
      body_wensdata: [],
      standard_data: ["强条强标", "建筑", "结构", "给排水", "燃气","暖通", "电气", "勘察", "智能化", "声学", "节能", "规划", "建筑/施工管理", "市政", "所有"],
      activeName: 'tuzhi',
      qiangtiaos:false,
      dataMast: '',
      recheck: true,
      showexport: false,
      self_work: [],
      body_work: [],
      other_work: [],
      common_show: false,
      criterion_show: false,
      showInfo: false,
      criterion_form: {},
      noDrawing: false,
      showpost: false,
      arr:{},
      arrid:'',
      problem_show:false,
      common_form: {
        data:{
          keyword:'',
          status:'所有项目'
        },
        loading:true,
      },
      arrb:[],
      rcid:'',
      table:{
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        // loading:true,
        data:[]
      },
      commonlist: {
        data: [],
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      taskCensorCircs:'',
      problemTypeOptions: PROBLEM_TYPE_OPTIONS,
      problemSubMajorOptions:[],
      professionalMB:[],
      data: {
        backReason: "",
        drawingNumbers: []
      },
      type: "",
      typeQuery: "",
      tree: {
        data: [
          {
            name: ""
          }
        ]
      },
      status: {
        drawing: true
      },
      taskID: "",
      defaultProps: {
        children: "children",
        label: "label"
      },
      iframe_url: "",
      plugin :{},
      perfesion:true,
      professionals:true,
      backToMasterCheckOnStatus:false,
      dwgDownload:false,

    };
  },
  created() {
   this.problem_show = false;
    this.typeQuery = this.$route.query.type;
    this.query();
   
  },
  // watch: {
  //   clientHeight(val) {
  //     if (!this.timer) {
  //       this.clientHeight = val;
  //       this.timer = true;
  //       let that = this;
  //       setTimeout(function() {
  //         //   that.height();
  //         that.timer = false;
  //       }, 100);
  //     }
  //   }
  // },
  mounted() {
    
   this.plugin = new PDFPlugin('pdf-container');
   this.getstandData();
  //  this.dragControllerDiv();
  },
  methods: {
      //清除
      clean(){
      },
      //判断专家
          getzhengd() {
        this.$http.get(this.url.otherdata).then(res => {
     
          if (res.body.result) {
            this.showexport = true;
            this.id = res.body.result.id;
            this.profession = res.body.result.profession;
            if(this.profession == '建筑'){
              this.opinionForm.professional = "建筑专业"
              this.professionals = true;
            }else if(this.profession == '结构'){
              this.opinionForm.professional = "结构专业"
              this.professionals = true;
            }else if(this.profession == '给排水'){
              this.opinionForm.professional = "给排水专业"
              this.professionals = true;
            }else if(this.profession == '暖通'){
              this.opinionForm.professional = "暖通专业"
              this.professionals = true;
            }else if(this.profession == '电气'){
              this.opinionForm.professional = "电气专业"
              this.professionals = true;
            }else if(this.profession == '岩土工程勘察'){
              this.opinionForm.professional = "勘察专业"
              this.professionals = true;
            }else{
              this.opinionForm.professional = "其他专业"
              this.professionals = true;
            }
          } else {
            this.showexport = false 
          }
        })
      },
      // 查询发送对接信息
    queryzuobiao(data){
       this.$http.get(
          '/design/problem/list?drawingNumber='+data.id
            ).then((resp) => {
            if(resp.data.result){
            let acarr = resp.data.result.self
            let arrb =[]
            acarr.forEach(item => {
                let data = {};
                data.rcid = item.id;
                data.flags = item.annotXml;
                arrb.push(data);
            });
            let cache = ''
            // if(data.readOnly==true){
            //   cache = true
            // }else{
            //   cache = false
            // }
      
            this.plugin.open({
              url : 'http://180.103.123.58:8088//upload'+ data.url,
              status :data.status,
              expert : data.disabled,
              cache:false,//不缓存
              listener : this.drawing_listener,
              data:arrb
            });
            }
          
            
            })
    },
  
    //树状图展开 以及对接  
    selectTreeID(data, node, self) {
      let ac = data
      this.perfesionName = data.profession;
      this.treeNode = data;
      this.arrid = data.id;
      this.showInfo = false;
      if(data.hasOwnProperty('url')==true){
         
      this.opinionFormname = data.label
      // this.shenchalist(this.arrid);
      // this.queryzuobiao(ac);不需要查询意见列表
       this.plugin.open({
              url : 'http://180.103.123.58:8088//upload'+ data.url,
              status :-1,
              expert : true,
              cache:true,//不缓存
              listener : this.drawing_listener,
              // data:arrb //不需要回显意见
            });
          this.showexport = true;
          this.noDrawing = false;
        this.currpdf_parentid = this.findParentID(node);
      }
      this.dwgDownload = false;
       if(data.type==='drawing'){
          if(data.name.indexOf(".dwg")>0){
            this.dwgDownload = true;
          }
        }
       this.backToMasterCheckOnStatus = false;
        if(data.readOnly === false){
          if(data.children[0].expertType === 'SecondCensor'){
            this.backToMasterCheckOnStatus = true;
          }
        }
        if(data.status==5 || data.status== -1||data.readOnly==true){
          this.noDrawing = true;
        }
        this.downloadActive = '',
        this.projectBoxShow = false;
        this.backOn = false;
        this.clickedNodeData = data;
         if (data.children && data.children.length && data.children[0].type == 'archive') {
          // if(this.$stor){
          // }
          this.problem_show = true
          // this.getproblem({
          //   taskId: this.query_id,
          //   profession: data.name
          // })
          this._drawingNumber = {
            taskId: this.query_id,
            profession: data.name
          };
          //专业
          this.clickedNodeData.checkOnReson = data.children[0].checkOnReson
            //专业意见单
          this.PDFOpenFile(data.children[0].id)
        }
        if (data.type && data.type == "archive") {//单体意见单
          data.readOnly ? this.defdps = false : this.defdps = true;
          data.number > 1 ? this.reexamine = true : this.reexamine = false;
          //单体
          this.problem_show = true;
          // this.getproblem({
          //   taskId: this.$route.query.id,
          //   projectID: data.projectId,
          //   profession: data.profession
          // })
          this._drawingNumber = {
            taskId: this.query_id,
            projectID: data.projectId,
            // profession: data.name
          };
          this.opinionForm.drawingNumber = '';
          this.noDrawing = true;
          this.PDFOpenFile(data.id)
          this.showpost = false
        } else {
          this.showpost = true;
          this.defdps = false;
          if (data.readOnly) {
            this.showInfo = false
          }
        };
       if (data.url) { // pdf
          this.problem_show = true;
          this.activeGUID = '';
          this.currpdf_parentid = this.findParentID(node);
          if (node.parent.data.readOnly || node.parent.data.trash) {
            this.noDrawing = true
          } else {
            this.noDrawing = false
          }
           this.noDrawing = false
          this.opinionForm.drawingNumber = data.id;
          this._drawingNumber = data.id;
          if(!data.disabled){
            this.showInfo = true;
            this.backOn = false;
          }
        }
    },
    PDFOpenFile(id){
        this.$http.get(
         '/design/opinions/pdfSign/'+id
        ).then(res => {
           this.plugin.open({
            url : res.bodyText,
            status : 1,
            expert: true,
            cache:false,//不缓存
        });
        });
       
    },
    drawing_listener(event,obj){
      switch(event){
        case 'newReviewComments':
          this.newReviewComments();
          break;
        case 'removeFlags':
          this.removeFlags(obj);
          break;  
        case 'fullscreen':
          this.fullscreen();
          break;
          case 'openReviewComments':
          this.openReviewComments(obj);
          break; 
          case 'openSuccess':
          this.openSuccess();
          break; 
      }
    },
    newReviewComments(){  
        this.opinion_show = true;
        this.resetForm();
    },
    removeFlags(obj){
     this.problemSave1(obj);
    },
         fullscreen(){
       let editor = document.getElementById('pdf-container');
        if(editor.requestFullscreen) {
          editor.requestFullscreen();
            }else if(editor.mozRequestFullScreen) {
              editor.mozRequestFullScreen();
            }else if(editor.webkitRequestFullscreen) {
              editor.webkitRequestFullscreen();
            }else if(editor.msRequestFullscreen) {
              editor.msRequestFullscreen();
            }
     },
     openReviewComments(obj){
       let url = '/design/problem/'
       this.$http.get(url+obj.rcid)
       .then(res=>{
         this.opinion_show = true;
         this.opinionForm = res.data.result
       })

     },
      openSuccess(){

      },
       pdfword(data) {
        let statusnum = data.drawing.drawingStatus
        let rcid = data.id
             if (data.annotXml) {
            this.plugin.open({
              url:'http://180.103.123.58:8088//upload'+data.drawing.blueprintPath,
              status : statusnum,
              expert:data.readOnly,
              listener : this.drawing_listener,
              data:[{rcid:rcid,flags:data.annotXml}]
            })
          this.plugin.curEditorWindow.findFlags(rcid)
            this.showInfo = true;
            this.opinionForm = data
        } else {
           data.projectID = data.id
          this.opinionForm = JSON.parse(JSON.stringify(data));
          this.opinion_show = true
          if(data.isSelf&&!data.isSubmit)this.opinionForm.myself = true
        }
      },
      body_wens(data) {
        this.body_wensdata = data
      },
      // 同图对比
         diffPDF() {
         if (this.diffPDFName == '开始对比') {
          let data = this.tree.data,
            disabledArray = [];
          let fa = (it) => {
            it.forEach(item => {
              if (item.disabled) {
                disabledArray.push(item)
                item.disabled = false
              }
              ;
              if (item.children) {
                fa(item.children)
              }
            })
          };
          fa(data);
          this.disabledArray = disabledArray;
          this.diffPDFName = '同图对比'
        } else {
          let arrays = this.diffCheckArray.filter(item => item.type === "drawing" && item.url)
          if (arrays.length !== 2) {
            alert('请选择两张图纸进行对比');
            return false
          }
          let GolDiffPdf = document.getElementById("DiffPdfOBJ");
          let data ={}
          data.pdf1 = 'http://180.103.123.58:8088//upload'+arrays[0].url;
          data.pdf2 = 'http://180.103.123.58:8088//upload'+arrays[1].url;
          data.name1 = arrays[0].name;
          data.name2 = arrays[1].name;
          this.plugin.compareTwo(data)
          let at = (it) => {
            it.forEach(item => {
              if (this.disabledArray.filter(da => da.node_key == item.node_key).length) {
                item.disabled = true
              }
              ;
              if (item.children) {
                at(item.children)
              }
            })
          }
          at(this.tree.data)
          this.disabledArray.forEach(item => {
            this.$refs.tree.setChecked(item, false)
          });
          this.disabledArray = []
          this.diffPDFName = '开始对比'
        }
        // 同图对比fun
      },
      //退回审查人
        updatebackToMasterCheckOn(){
        for (var i = 0; i < this.treeNode.children.length; i++) {
          if (this.treeNode.children[i].profession === this.mprofession) {
            this.$http.get(
              location.protocol + '//' + location.host + '/draw/opinions/backToMasterCheckOn?id=' + this.treeNode.children[i].id+"&number="+this.treeNode.children[i].number
            ).then((resp) => {
              if(resp.ok && resp.body.status === 200){
                this.$message.success("已回退审查人")
              }else{
                this.$message.error("操作失败");
              }
            })
          }
        }
      },
        //添加审查意见
      onPDF_addnew(){
        this.opinion_show=true;
        this.activeGUID='';
        this.opinionForm.myself = true;
        this.opinionForm.annotXml='';
        delete this.opinionForm.projectID;
      },
      //树节点信息
      treeCheck(a, b) {
        var json = [];
        this.diffCheckArray = b.checkedNodes;
        this.diffCheckArray.forEach(res=>{
          json.push(res.id)
        })
        this.idArray = json;
      },
      //审查意见列表
      shenchalist(data){
        this.$http.get('/draw/problem/list/?drawingNumber='+ this.arrid)
        .then(res=>{
          this.body_work = res.data.result.self
          this.problem_show = true
        })
        
      },
       onPDF_selectAnnot(ZSGuid, ZSType, Extend) { // pdf 注释选择后的回调
        this.opinion_show = true;
        //this.activeGUID.push(ZSGuid)
         this.activeGUID = ZSGuid;
        let problem = this.problemMap[ZSGuid];
        if (problem) this.opinionForm = JSON.parse(JSON.stringify(problem));
      },
        //单体
      getproblem(data) {
        let json = []
        this.mprofession = data.profession;
        this.$http.get(this.url.problem, {
          params: data
        }).then(res => {
          this.dataMast = res.body.result[0].examineID;
          res.body.result.forEach(o=>{
            if(o.profession == this.perfesionName){
              json.push(o)
            }else{
              return
            }
          })
          this.body_work = json;
          this.other_work = []
        })
      },
      // 缺图纸
       no_drawing() {
        var url;
        let form = {
          projectID: this.clickedNodeData.projectID,
          profession: this.clickedNodeData.profession
        }
        this.PDFReader_show = false;
        this.$prompt('请输入原因', '提示').then(res => {
          if(this.taskCensorCircs == '4'){
            url = this.url.noDrawing;
            form.backReason = res.value;
          }else{
            url = this.url.onedrawing;
            form.onebackReason = res.value;
          }
          this.$http.post(url, form).then(resp => {
            if (resp.body.status == 200) {
              this.$message.success('操作成功');
              this.query()
              this.PDFReader_show = true;
            } else {
              this.$message({
                type: 'error',
                showClose: true,
                message: '错误' + resp.body.message
              })
            }
          })
        }).catch(err => {
          this.PDFReader_show = true;
        })

      },
      self_wens(data) {
        this.self_wensdata = data
      },
      pdfset(data) {
       
      },
      //删除意见
       self_all_del(ty, ten = true) {
        // 删除意见主fun
        let ids = []
        switch (ty) {
          case 'self':
            this.self_wensdata.forEach(item => {
              ids.push(item.id)
            });
            break;
          case 'other':
            this.other_wensdata.forEach(item => {
              ids.push(item.id)
            });
            break;
          case 'body':
            this.body_wensdata.forEach(item => {
              ids.push(item.id)
            });
            break;
        }
        ;
        if (confirm('您确定要删除所选的内容吗?')) {
          this.$http.post(this.url.alldelete, ids).then(res => {
            if (res.body.status == 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              if (ten)
              {
                this.plugin.curEditorWindow.removeFlags(ids);
                this._render_pdfProblem(this._drawingNumber)
              }
              else
              {
                this.plugin.curEditorWindow.removeFlags(ids);
                //  this.shenchalist(this.arrid)
              }
            } else {
              this.$message({
                type: 'warning',
                message: '错误:' + res.body.message,
                showClose: true
              })
            }
          })
        }
      },
        // 获取图纸意见标注接口
      getProblems(drawingNumber) {
        let url = this.showexport 
        // ? this.url.problems : this.url.getProblems
        return this.$http.get(
          `${url}`, {
            params: {
              drawingNumber
            }
          }
        )
      },
            _render_pdfProblem(id) {
        // 打开图纸后调用审查标记
        for (let name in this.problemMap) {
          this.pr.DeleteAnnot(name, '')
        }
        this.getProblems(id).then(
          (resp) => {
            if (resp.status == 200) {
              // 初始化
              this.problemMap = {};
              this.xmlMap = {};
              let regx = /<GUID>(.*?)<\/GUID>/g;
              let xml_init = '';
              let list = []
              if (this.showexport) {
                resp.body.result.self.forEach(item => {
                  item.myself = true;
                  if(this.opinionForm.projectID ==  item.id){
                    this.opinionForm.myself = true;
                  }
                });
                resp.body.result.other.forEach(item => {
                  item.myself = false;
                });
                this.self_work = JSON.parse(JSON.stringify(resp.body.result.self));
                this.other_work = JSON.parse(JSON.stringify(resp.body.result.other));
                list = Object.assign(resp.body.result.self, resp.body.result.other);
              } else {
                this.self_work = resp.body.result;
                list = resp.body.result
              }
              list.forEach(item => {
                let _this = this;
                xml_init += item.annotXml
                // let guid = ''
                if (item.annotXml) {
                  item.annotXml.replace(regx, function (m, p) {
                    _this.problemMap[p] = item
                    _this.xmlMap[p] = item.annotXml
                    // guid = p
                    return m
                  })
                  item.projectID = item.id;
                  // this.problemMap[guid] = item
                  // this.xmlMap[guid] = item.annotXml
                }
              })

              xml_init = `<root>${xml_init}</root>`;
              this.pr.AddAnnot(3, xml_init, "");
              if (this.pdfword_re) {
                this.pr.SetReadZoom(100);
                this.pr.GotoAnnot(this.pdfword_re, '');
                this.pdfword_re = ''
              }
            } else {
              console.log('getProblems fail');
            }
          },
          (err) => {
            console.log(err);
          }
        );
      },
  // 强条change
        qiangtiao(data){
        if(this.problemTypeOptions[1].label == data){
            this.qiangtiaos = true
        }else{
          this.qiangtiaos = false;
          this.opinionForm.problemSubMajor = '';
        }
      },

        //返回目录
       goTree() {
        // this.resetForm();
        this.opinion_show = false;
      },
   // 复制意见
      copyOpinion() {
        let {
          problemType,
          problemSubMajor,
          isHiddenDanger,
          dangerType,
          gbdescription,
          normalName,
          normalNum,
          clauseNum,
          hiddenDangerReason,
          opinionType,
          problemDescription,
          professional,
        } = JSON.parse(JSON.stringify(this.opinionForm));

        this.COPYOPINION = {
          problemType,
          problemSubMajor,
          isHiddenDanger,
          dangerType,
          gbdescription,
          normalName,
          normalNum,
          clauseNum,
          hiddenDangerReason,
          opinionType,
          problemDescription,
          professional
        };
        this.$message.success('复制成功!')
      },
         // 粘贴意见
      pasteOpinion() {
        let opinion = JSON.parse(JSON.stringify(this.COPYOPINION));
        this.opinionForm = Object.assign(this.opinionForm, opinion);
      },

      findParentID(node) {
        if (node.parent.data.id) {
          return node.parent.data.id;
        } else if (node.parent.parent.data.id) {
          return node.parent.parent.data.id
        } else {
          return ''
        }
      },

      //保存意见
   submitProblem_handle() {
        this.arr = this.plugin.curEditorWindow.getNewFlags();
        //  
         this.plugin.curEditorWindow.bindReviewComments(this.arrid)
        this.$refs.opinionForm.validate((valid) => {
          if (valid) {
            let index;
            let drawingData = {
              annotXml: ''
            };
            let data = Object.assign({}, this.opinionForm, drawingData, {
              isHiddenDanger: this.opinionForm.isHiddenDanger ? 1 : 0
            });
            if (this.activeGUID) {
                this.problemMap[this.activeGUID] = data;
            };
            if (data.projectID) {
              this.problemSave(data).then(
                (resp) => {
                  // this._render_pdfProblem(this._drawingNumber);
                  this.resetForm();
                  this.opinionForm.projectID='';
                  this.opinion_show = false;
                  this.activeGUID = '';
                  this.noDrawing = false;
                  //this.query();
                },
                (err) => {
                  this.opinion_show = false;
                  this.opinionForm.projectID='';
                  this.activeGUID = '';
                  this.noDrawing = false;
                }
              );
            } else {
              this.problemSubmit(data).then(
                (resp) => {
                  this._render_pdfProblem(this._drawingNumber);
                  this.resetForm();
                  this.opinion_show = false;
                  this.activeGUID = '';
                  this.noDrawing = false;
                  // this.shenchalist(this.arrid);
                  //this.query();
                },
                (err) => {
                  this.opinion_show = false;
                  this.activeGUID = '';
                  this.noDrawing = false;
                }
              );
            }
          } else {
            return false
          }
        })
      },
      // 图纸意见标注接口
      problemSubmit(data) {
        data.annotXml = JSON.stringify(this.arr)
        data.drawingNumber = this.arrid;
        return this.$http.post(
          `${this.url.problemSubmit}/${this.currpdf_parentid}`,
          data
        )
      },
      //清空表单
       resetForm() {
        let arr = ['problemType', 'problemSubMajor', 'dangerType', 'gbdescription', 'normalName','normalNum','clauseNum', 'problemDescription','professional', 'hiddenDangerReason', 'gbcaption', 'opinionType']
        arr.forEach(item => {
          this.opinionForm[item] = ''
        })
        //			this.$refs['opinionForm'].resetFields()
      },
      problemSave(data) {
        data.annotXml =null;
        return this.$http.post(this.url.problemSave + data.id, data)
      },
      problemSave1(data) {
        this.opinionForm.annotXml = JSON.stringify(data.flags)
        if(this.opinionForm.annotXml==''){
          this.$http.post(this.url.alldelete,data.rcid ).then(res => {
            if (res.body.status == 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
            }
        })
      }else{
         return this.$http.post(this.url.problemSave+ data.rcid, this.opinionForm)
      }
       
      },
      // 标准查询弹层数据
         getstandData() {
        let loading = this.$loading();
        var _that = this;
        let form = {
          cmd: 'api_yst_content_loadby',
          stdno: String(this.stdid),
          type: 0,
          caption: this.stand_search,
          pagesize: 10000,
          pageindex: 0
        }
        $.ajax({
          type: "get",
          url: this.url.rsi,
          data: form,
          success: function (res) {
            res = res.replace(/\n/g,"");
            res = JSON.parse(res);
            _that.stand_contant = res.records;
            loading.close()
          }
        });
      },
       getstandList() {
        let loading = this.$loading()
        this.stand_search = '';
        this.stand_contant = [];
        this.common_list = [];
        var _that = this;
        let form = {
          cmd: 'api_yst_topical_loadby',
          major: this.standard,
          type: 0,
          caption: this.standCaption,
          region: '',
          pagesize: 1000,
          pageindex: 0
        }
        $.ajax({
          type: "get",
          url: this.url.rsi,
          data: form,
          success: function (res) {
            res = res.replace(/\n/g,"");
            res = JSON.parse(res);
            _that.common_list = res.records;
            loading.close();
          }
        });

      },
      //翻页
      getcommon(page = '') {
        if (page) {
          this.commonlist.currentPage = page
        }
        let params = {
          pageSize: 10,
          currentPage: this.commonlist.currentPage
        }
        this.$http.get(this.url.commonlist, {
          params
        }).then(res => {
          this.commonlist.data = res.body.result.data;
          this.commonlist.total = res.body.result.total;
        })
      },
      //常用意见
      cellCommon(row) {
        let professionaltemp = this.opinionForm.professional;
        this.resetForm();
        this.opinionForm.problemType = row.violateType;
        this.opinionForm.problemSubMajor = row.mandatoryStandardType;
        this.opinionForm.isHiddenDanger = row.isSecurity ? 1 : 0
        this.opinionForm.dangerType = row.security
        this.opinionForm.hiddenDangerReason = row.securityDescription
        //this.opinionForm.gbdescription = row.gbno
        this.opinionForm.normalName = row.normalName
        this.opinionForm.normalNum = row.normalNum
        this.opinionForm.clauseNum = row.clauseNum
        this.opinionForm.professional = professionaltemp
        this.opinionForm.problemDescription = row.commonStandar1
        this.opinionForm.gbcaption = row.commonStandar2
        this.opinionForm.opinionType = row.commonStandar3
        this.common_show = false
        // this.$http.get(this.url.commonapply+id).then(res=>{
        // 	this.opinionForm = res.body.result;
        // 	this.opinionForm.myself = true;
        // 	this.common_show =false
        // })
      },
        // dialog弹层查询
       query1(page = 1){
        this.table.loading = true;
        let filterList = "";
        if(this.common_form.data.keyword != ""){
          filterList += "?keyword=" + this.common_form.data.keyword
        }
        if (page) {
          this.commonlist.currentPage = page
        }
        let params = {
          pageSize: 10,
          currentPage: this.commonlist.currentPage,
        }
        this.$http.get(
          this.url.query1 + filterList,{params}
        ).then((res) => {
          if (res.body.status === 200) {
            this.commonlist.data = res.data.result.data;
            this.commonlist.total = res.data.result.total;
            this.table.loading = false;
          } else {
            this.$message.error('查询失败，请联系管理员');
          }
        },(error)=>{
          this.$message.error('查询失败，请联系管理员');
        })

      },
    query() {
      // 请求树形图数据
      this.$http.get("/design/tasks/drawcate/" + this.$route.query.id).then(
        res => {
          this.tree.loading = false;
          if (res.body.status === 200) {
            res.data.result.forEach(item => {
              let n = 0;
              let fa = data => {
                let num = data.filter(ta => {
                  if (ta.children) {
                    fa(ta.children);
                  }
                  return ta.url && ta.label;
                }).length;
                n += num;
              };
              fa(item.children);
              item.label = item.label + `(共${n}张)`;
            });
            // res.data.result.forEach(item=>{
            // 	item.label=item.label+`(共${this.dawr_number(item)}张)`
            // });
            this.tree.data = res.data.result;
          } else {
            this.$message.error("查询失败，请联系管理员");
          }
        },
        error => {
          this.$message.error("查询失败，请联系管理员");
        }
      );
    },
    //动态滚动事件
      // dragControllerDiv: function () {
      //     var resize = document.getElementsByClassName('resize');
      //     var left = document.getElementsByClassName('left');
      //     var mid = document.getElementsByClassName('main');
      //     var box = document.getElementsByClassName('components-container');
      //   for (let i = 0; i < resize.length; i++) {
      //               // 鼠标按下事件
      //               resize[i].onmousedown = function (e) {
      //                   //颜色改变提醒
      //                   resize[i].style.background = '#818181';
      //                   var startX = e.clientX;
      //                   resize[i].left = resize[i].offsetLeft;
      //                   // 鼠标拖动事件
      //                   document.onmousemove = function (e) {
      //                       var endX = e.clientX;
      //                       var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
      //                       var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

      //                       if (moveLen < 32) moveLen = 32; // 左边区域的最小宽度为32px
      //                       if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

      //                       resize[i].style.left = moveLen; // 设置左侧区域的宽度

      //                       for (let j = 0; j < left.length; j++) {
      //                           left[j].style.width = moveLen + 'px';
      //                           mid[j].style.width = (box[i].clientWidth - moveLen - 10) + 'px';
      //                       }
      //                   };
      //                   // 鼠标松开事件
      //                   document.onmouseup = function (evt) {
      //                       //颜色恢复
      //                       resize[i].style.background = '#d6d6d6';
      //                       document.onmousemove = null;
      //                       document.onmouseup = null;
      //                       resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
      //                   };
      //                   resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
      //                   return false;
      //               };
      //           }
      //   },
  }
};
</script>

<style  scoped>
  .components-container {
    position: relative;
    height: 100vh;
  }

  .left-container {
    height: 100%;
  }

  .top-container {
    height: 100%;
  }
  html,
  body,
  #app {
    height: 100%;
  }

  .el-main {
    overflow: initial;
  }

  .info-op,
  .save-op {
    font-size: 14px;
  }

  .info-op .el-row {
    margin-top: 20px;
  }

  .info-op .el-row .el-button,
  .save-op .el-row .el-button {
    width: 100%;
  }

  span.el-tree-node__label {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .font-green {
    color: #73e64d;
  }

  .font-red {
    color: #e74141;
  }

  .common_list {
    padding: 10px 0;
    font-size: 14px;
    border-bottom: 1px solid #EAEAEA;
    cursor: pointer;
  }

  .common_list:hover {
    background: #efefef;
  }

  .criterion_item {
    cursor: pointer;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    border-right: 1px solid #000;
  }

  .criterion_item > div {
    padding: 5px;
    text-align: left;
    border-bottom: 1px solid #EAEAEA;
  }

  .criterion_item .active {
    background: #eaeaea;
  }

  .criterion_item > div:active {
    background: #eaeaea;
  }
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #efd2b3!important;
}
.el-tree-node__content:hover {
    background-color: #f6ebdf !important;
}
.el-icon-caret-top:before {
    content: "\E791";
    color:red;
}
#dragbar{
  cursor: pointer;
}
#dragbar :hover{
  cursor:pointer; 
}
</style>


// WEBPACK FOOTER //
// src/views/login/pdfIndexAssist.vue